import { Button, Card, FormControl, Grid, MenuItem } from "@mui/material";
import { useAppContext } from "AppContext";
import GKSelect from "components/GKSelect";
import GKTextField from "components/GKTextField";
import Heading from "components/Holdings";
import { useForm } from "react-hook-form";
import { useParams } from "react-router-dom"; // Import useParams
import axiosInstance from "utils/axiosInstance";
import {
  COMPANY_CAP,
  COMPANY_ETF_SUB_TYPE,
  COMPANY_INSTTYPE,
  COMPANY_STATUS,
  INSTRUMENT_SUB_TYPE,
  MUTUAL_FUND_SUB_TYPE,
} from "utils/constants";

const FundamentalDetails = ({ companyDetails, refetch }) => {
  const { id } = useParams();

  const {
    state: { currentUser },
  } = useAppContext();

  const isDisabled = currentUser?.phone === "9911223344";

  const { handleSubmit, register, watch, setValue } = useForm({
    defaultValues: {
      cap: companyDetails?.cap || "",
      finCode: companyDetails?.finCode || "",
      house: companyDetails?.house || "",
      industry: companyDetails?.industry || "",
      instType: companyDetails?.instType || "",
      kiteCode: companyDetails?.kiteCode || "",
      name: companyDetails?.name || "",
      sector: companyDetails?.sector || "",
      shortName: companyDetails?.shortName || "",
      status: companyDetails?.status || "",
      instSubType: companyDetails?.instSubType || "",
      mfSubType: companyDetails?.mfSubType || "",
    },
  });

  const instType = watch("instType");

  const onSubmit = async (values) => {
    try {
      const res = await axiosInstance.put(
        `/admin-instrument/${id}/update/`,
        values
      );
      console.log("Success:", res.data.message);
      refetch();
    } catch (error) {
      console.error(
        "Error:",
        error?.response?.data?.message || "Something went wrong"
      );
    }
  };

  return (
    <Card sx={{ p: 3, boxShadow: 3 }}>
      <Heading
        border
        heading="Fundamental Details"
        subHeading="Please enter the following details"
      />
      <form onSubmit={handleSubmit(onSubmit)} id="fundamental-details">
        <Grid container spacing={2} mt={2}>
          <Grid item xs={6}>
            <FormControl variant="standard" fullWidth>
              <GKTextField
                name="name"
                {...register("name")}
                onChange={(e) => setValue("name", e.target.value)}
                value={watch("name")}
                inputLabel="name"
                disabled={isDisabled}
              />
            </FormControl>
            <FormControl variant="standard" fullWidth>
              <GKTextField
                name="shortName"
                {...register("shortName")}
                onChange={(e) => setValue("shortName", e.target.value)}
                value={watch("shortName")}
                inputLabel="Short Name"
                disabled={isDisabled}
              />
            </FormControl>
            <FormControl fullWidth variant="standard">
              <GKTextField
                name="FinCode"
                {...register("finCode")}
                onChange={(e) => setValue("finCode", e.target.value)}
                value={watch("finCode")}
                inputLabel="Fin Code"
                disabled={isDisabled}
              />
            </FormControl>
            <FormControl fullWidth variant="standard">
              <GKSelect
                inputLabel="InstType"
                {...register("instType")}
                onChange={(e) => setValue("instType", e.target.value)}
                value={watch("instType")}
                disabled={isDisabled}
              >
                {COMPANY_INSTTYPE.map((dataItem, i) => (
                  <MenuItem key={i} value={dataItem.value}>
                    {dataItem.name}
                  </MenuItem>
                ))}
              </GKSelect>
            </FormControl>
            <FormControl fullWidth variant="standard">
              <GKSelect
                inputLabel="Cap"
                {...register("cap")}
                onChange={(e) => setValue("cap", e.target.value)}
                value={watch("cap")}
                disabled={isDisabled}
              >
                {COMPANY_CAP.map((dataItem, i) => (
                  <MenuItem key={i} value={dataItem.value}>
                    {dataItem.name}
                  </MenuItem>
                ))}
              </GKSelect>
            </FormControl>
            {instType === "ETF" && (
              <FormControl variant="standard" fullWidth>
                <GKSelect
                  inputLabel="ETF Sub Type"
                  {...register("etfSubType")}
                  onChange={(e) => setValue("etfSubType", e.target.value)}
                  value={watch("etfSubType")}
                  disabled={isDisabled}
                >
                  {COMPANY_ETF_SUB_TYPE.map((dataItem, i) => (
                    <MenuItem key={i} value={dataItem.value}>
                      {dataItem.name}
                    </MenuItem>
                  ))}
                </GKSelect>
              </FormControl>
            )}
            <FormControl variant="standard" fullWidth>
              <GKSelect
                inputLabel="Mutual Funds Sub Type"
                {...register("mfSubType")}
                onChange={(e) => setValue("mfSubType", e.target.value)}
                value={watch("mfSubType")}
                disabled={isDisabled}
              >
                {MUTUAL_FUND_SUB_TYPE.map((dataItem, i) => (
                  <MenuItem key={i} value={dataItem.value}>
                    {dataItem.name}
                  </MenuItem>
                ))}
              </GKSelect>
            </FormControl>
          </Grid>
          <Grid item xs={6}>
            <FormControl variant="standard" fullWidth>
              <GKTextField
                inputLabel="Sector"
                {...register("sector")}
                onChange={(e) => setValue("sector", e.target.value)}
                value={watch("sector")}
                disabled={isDisabled}
              />
            </FormControl>
            <FormControl variant="standard" fullWidth>
              <GKTextField
                inputLabel="Industry"
                {...register("industry")}
                onChange={(e) => setValue("industry", e.target.value)}
                value={watch("industry")}
                disabled={isDisabled}
              />
            </FormControl>
            <FormControl variant="standard" fullWidth>
              <GKTextField
                inputLabel="House"
                {...register("house")}
                onChange={(e) => setValue("house", e.target.value)}
                value={watch("house")}
                disabled={isDisabled}
              />
            </FormControl>
            <FormControl variant="standard" fullWidth>
              <GKTextField
                inputLabel="Kite Code"
                {...register("kiteCode")}
                onChange={(e) => setValue("kiteCode", e.target.value)}
                value={watch("kiteCode")}
                disabled={isDisabled}
              />
            </FormControl>
            <FormControl variant="standard" fullWidth>
              <GKSelect
                inputLabel="Status"
                {...register("status")}
                onChange={(e) => setValue("status", e.target.value)}
                value={watch("status")}
                disabled={isDisabled}
              >
                {COMPANY_STATUS.map((dataItem, i) => (
                  <MenuItem key={i} value={dataItem.value}>
                    {dataItem.name}
                  </MenuItem>
                ))}
              </GKSelect>
            </FormControl>
            <FormControl variant="standard" fullWidth>
              <GKSelect
                inputLabel="Instrument Sub Type"
                {...register("instSubType")}
                onChange={(e) => setValue("instSubType", e.target.value)}
                value={watch("instSubType")}
                disabled={isDisabled}
              >
                {INSTRUMENT_SUB_TYPE.map((dataItem, i) => (
                  <MenuItem key={i} value={dataItem.value}>
                    {dataItem.name}
                  </MenuItem>
                ))}
              </GKSelect>
            </FormControl>
          </Grid>
        </Grid>
        <Grid container mt={3} justifyContent="flex-end">
          <Button
            sx={{
              fontSize: "0.7rem",
              fontFamily: '"Arial", sans-serif',
              textTransform: "none",
            }}
            variant="contained"
            color="primary"
            type="submit"
            disabled={isDisabled}
          >
            Submit
          </Button>
        </Grid>
      </form>
    </Card>
  );
};

export default FundamentalDetails;
